export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-light dark:bg-surface-dark">
      <div className="text-center">
        <div className="relative w-16 h-16 mx-auto mb-4">
          {/* Outer ring */}
          <div className="absolute inset-0 border-4 border-neutral-200 dark:border-neutral-700 rounded-full" />
          {/* Spinning segment */}
          <div className="absolute inset-0 border-4 border-transparent border-t-primary-500 rounded-full animate-spin" />
        </div>
        <p className="text-lg font-medium text-neutral-600 dark:text-neutral-400">
          Loading WEZ...
        </p>
      </div>
    </div>
  );
}
